<template>
 <page>

   <head-nav title="language.update_newsitem">
      <icon-button-back slot="left"></icon-button-back>
      <icon-button-home slot="right"></icon-button-home>
    </head-nav>

  <scroll-page>
    
    
    <page-padding>
      
      
      

      <ui-input title="language.title" type="text" v-bind:val="title" @input="(v)=>{title = v}">
        <div slot="after"> <ui-icon @click.native="toggleSticky" icon="thumbtack" backgroundColor="transparent" :color="computeStickyColor" class="thumbtack"/></div>
      </ui-input>
     
      <!--<ui-textarea title="language.provide_description" v-bind:val="description" @input="(v)=>{bb_description = v}"></ui-textarea>-->
      <ui-htmlarea title="language.provide_description" v-bind:val="description" @input="(v)=>{bb_description = v}"></ui-htmlarea>
      <ui-input title="language.provide_youtube_url" type="text" v-bind:val="youtube_url" @input="(v)=>{youtube_url = v}"></ui-input>


      <!-- pick images mobile -->
      <button-action v-if="isMobile" :active="computeUploadImagesLeft>0" v-on:click.native="getCameraImage()" title="language.camera" ></button-action>
      <button-action v-if="isMobile" :active="computeUploadImagesLeft>0" v-on:click.native="getGalleryImages()" title="language.gallery" ></button-action>
      <button-action v-if="isMobile" :active="computeUploadImagesLeft>0" v-on:click.native="chooseMobileFile()" title="language.choose_mobile_file" ></button-action>


      <!-- pick images desktop variant -->
      <button-file v-if="!isMobile" :active="computeUploadImagesLeft>0" :multiple="true" accept="image/jpeg,image/png,application/pdf" title="language.choose_file" @change="getGalleryImagesBrowser"></button-file>
      

      </page-padding>
      <upload-gallery :key="mediaKey" :medias="medias"/>
      

      <page-padding>
      
      <fold-button v-if="computeShowFolder" title="language.delete_existing_images">

          <caroussel-gallery @selection="getSelection" :mode="gallery_mode" :medias="news_item.media"/>
      </fold-button>
      
      
        <!--<ui-check v-if="group_id==0" :val="check.app" v-on:selected="val=>{check.app = val}" title="language.place_in_schoolapp" />-->
        <ui-check v-if="computeOudersFeedCheck" :val="check.feed_ouders" v-on:selected="val=>{check.feed_ouders = val}" title="language.place_in_feed_ouders" />
        <ui-check :val="check.feed_groep" v-on:selected="val=>{check.feed_groep = val}" title="language.place_in_feed_groep" />
        <ui-check :val="check.website" v-on:selected="val=>{check.website = val}" title="language.place_on_website" />
        <ui-check :val="check.narrowcasting" v-on:selected="val=>{check.narrowcasting = val}" title="language.place_on_narrow" />
        <ui-check :val="check.allow_reactions" v-on:selected="val=>{check.allow_reactions = val}" title="language.allow_reactions" />
          
      <divider title=""/>
      <button-activate :active="buttonActive" v-on:click.native="confirm()" :title="computeTitle"></button-activate>
      
     </page-padding>

   </scroll-page>
   </page>
</template>

<script>


import { mapState } from 'vuex';
import ButtonActivate from '../components/buttons/ButtonActivate.vue';
import ButtonAction from '../components/buttons/ButtonAction.vue';
import PagePadding from '../components/PagePadding.vue';
import HeadNav from '../components/HeadNav.vue';
import IconButtonHome from '../components/buttons/IconButtonHome.vue';
import IconButtonBack from '../components/buttons/IconButtonBack.vue';
import UiCheck from '../components/UiCheck.vue'
import UiInput from '../components/UiInput.vue';
import UploadGallery from '../components/uploadGallery/UploadGallery.vue';
import ScrollPage from '../components/ScrollPage.vue';
import { imagePicker } from '../services/ImagePicker.js'
import { api } from '../services/Api';
import Page from '../pages/Page.vue';
import { modalService } from '../services/ModalService';
import i18n from "../language.js";
import { fileTransfer } from '../services/FileTransfer.js';
import { eventBus } from '../services/EventBus.js';
import UiHtmlarea from '../components/UiHtmlarea';
import Vue from 'vue';
import { history } from "../services/History.js";
import { GALLERY_MODE }  from '../components/caroussel/GALLERY_MODE.js';
import CarousselGallery from '../components/caroussel/CarousselGallery.vue';
import Divider from '../components/dividers/Divider.vue';
import FoldButton from '../components/buttons/FoldButton.vue'
import UiIcon from '../components/UiIcon.vue';
import { USER_LEVEL } from '../settings/USER_LEVEL.js';
import { cordovaInit } from '../services/CordovaInit.js';
import ButtonFile from '../components/buttons/ButtonFile.vue';
import { FILE_SIZE } from '../settings/FILE_SIZE.js';

export default {
  name: 'update-newsitem-page',
  data:function(){
    return{
      gallery_mode:GALLERY_MODE.SELECT_MULTIPLE,
      group_id:this.$route.params.id,
      itemId:this.$route.params.item_id,
      buttonActive:true,
      medias:[], // the images for uploading
      maxImages:20,
      mediaKey:0,
      title:"",
      description:"",
      youtube_url:"",
      bb_description:"",
      group:{ name:"no-name" },
      delete_ids:[], // list with photo ids to delete
      check:{
        feed_ouders:true,
        feed_groep:false,
        website:true,
        narrowcasting:false,
        pushnote:false,
        allow_reactions:false,
        sticky:false,
      },
      isMobile:cordovaInit.isMobile(),
    }
  },
  computed:{
    ...mapState([
       'groups','appSettings','user_schools','news_item'
       ]),
      upload_path:function(){
        var school=this.user_schools.find(school => school.active === 1);
        return api.getUrl(school,"add_news_item_photo.php");
      },
      computeTitle(){
        if(!this.buttonActive){
          return this.$t('language.working');
        }else{
           return this.$t('language.update_newsitem');
        }
      },
      computeUploadImagesLeft(){
        
        var imagesLeft=this.maxImages-this.medias.length;
        if(imagesLeft<0){ imagesLeft=0;}
        return imagesLeft;
      },
      computeOudersFeedCheck(){
        if(this.appSettings.user_level==USER_LEVEL.STUDENT){
          return false;
        }
       
        return true;
      },
      computeStickyColor(){
        if(this.check.sticky){
          return '#8CC63E';
        }
        return '#707070';
      },
      computeShowFolder(){
        return this.news_item.media ? this.news_item.media.length:false;
      },
  },
  components: {
    ButtonActivate,
    ButtonAction,
    PagePadding,
    HeadNav,
    IconButtonHome,
    IconButtonBack,
    UiInput,
    UiCheck,
    UploadGallery,
    Page,
    ScrollPage,
    UiHtmlarea,
    CarousselGallery,
    Divider,
    FoldButton,
    UiIcon,
    ButtonFile
  },
  methods:{
    back(){
      this.$router.push(history.get());
    },
    getSelection(selected){
      this.delete_ids=selected.map((index)=>{
        return this.news_item.media[index].id
      })
    },
    isFormComplete(){

      if(this.title===""){
          modalService.createAlert(i18n.t('language.form_incomplete_title'))
        return false;
      }

      return true
    },
    getCameraImage(){

      var args={
          allowEdit : false,
          targetWidth: 1920,
          targetHeight: 1920,
          quality: 70,
          mediaType: window.Camera ? window.Camera.MediaType.PICTURE : undefined,
          correctOrientation:true,
        };
      imagePicker.getCamera(args).then(media=>{
          this.medias.push(media);
          //this.mediaKey=new Date().getTime();
      })
    },
    getGalleryImages(){

      this.buttonActive=false;
      
       var args = {
        'selectMode': imagePicker.mediaType.IMAGE, //101=picker image and video , 100=image , 102=video
        'maxSelectCount': this.computeUploadImagesLeft, //default 40 (Optional)
        'maxSelectSize': FILE_SIZE.IMAGE, //180000000=180M (Optional) only android (15000000 15 mb)
      };
      

      imagePicker.getMedias(args).then( medias => {
        this.buttonActive=true;

        var c=0;
        medias.forEach(media=>{
          setTimeout(()=>{
            this.medias.push(media)
          },c*50);
          c++;
           
        })
        
      })

    },
    getGalleryImagesBrowser(e){
      
      
      imagePicker.fileListToMedias(e.target.files).then(result=>{
        
        var c=0;
        result.forEach(media=>{
          setTimeout(()=>{
           
            this.medias.push(media)
          },c*50);
          c++;
           
        })
      })

    },
    /* choose file on mobile*/
    chooseMobileFile(){
      //var types="application/pdf,audio/mpeg";
      var types="application/pdf";
      window.chooser.getFile(types).then(result=>{
          this.file=result;

          var fileSize=this.file.data.byteLength;
          
          if(fileSize> FILE_SIZE.FILE && FILE_SIZE.FILE>0){
            var txt=this.$t("language.file_limit_is")+" "+FILE_SIZE.FILE/1000000+"mb"
            modalService.createAlert(txt)
            return;
          }

         // check if filename has extension, if not
         // then give it an extension
         var extension=this.file.name.split(".")[1];

         var thumb;
         switch(this.file.mediaType){
          case "audio/mpeg":
            thumb=require('../assets/audio_bg.png');
            extension ? false : this.file.name+=".mp3";
          break;
          case "application/pdf":
            thumb=require('../assets/pdf_bg.png');
            extension ? false : this.file.name+=".pdf";
          break;
          default:
            modalService.createAlert("pick mp3 or pdf filetype");
            return;
          
         }

         
          // this.file.data is the uint8array data...
          var media={
            fileName:this.file.name,
            url:this.file.dataURI, /* dataURI is base 64 data */
            thumbnail:thumb,
            exifOrientation:0,
          }
          this.medias.push(media);
        })
    },
    confirm(){
      if(!this.isFormComplete()){
        return;
      }

      this.buttonActive=false;

      this.updateNewsItem();
     
    
    },
    loadNewsItem(){
      // load album
      var payload={id:this.itemId}
      
      this.$store.dispatch('get_news_item',payload).then(()=>{
        
        this.title=this.news_item.title;
        this.description=this.news_item.text;
        this.youtube_url=this.news_item.youtube_id;
        //this.check.app=(this.news_item.app=="1") ? true: false
        this.check.feed_ouders=(this.news_item.feed_ouders=="1") ? true: false
        this.check.feed_groep=(this.news_item.feed_groep=="1") ? true: false
        this.check.website=(this.news_item.website=="1") ? true: false
        this.check.narrowcasting=(this.news_item.narrowcasting=="1") ? true: false
        this.check.allow_reactions=(this.news_item.allow_reactions=="1") ? true: false
        this.check.sticky=(this.news_item.sticky=="1") ? true: false

      })
    },
    updateNewsItem(){
      
      // first create album
      var payload={
        id:this.itemId,
        content:this.bb_description,
        title:this.title,
        youtube_url:this.youtube_url,
        delete_photos:this.delete_ids,
        feed_ouders:this.check.feed_ouders ? 1:0,
        feed_groep:this.check.feed_groep ? 1:0,
        website:this.check.website ? 1:0,
        narrowcasting:this.check.narrowcasting ? 1:0,
        allow_reactions:this.check.allow_reactions ? 1:0,
        sticky:this.check.sticky ? 1:0,
      }
      
      this.$store.dispatch('update_news_item',payload).then(()=>{
       
        // start uploading medias first item
        this.uploadNextFile(this.itemId,0);
      });
      
      

    },
    allUploadFinished(){
        this.buttonActive=true;
        this.medias=[];
       
        
        Vue.$toaster.toast("language.news_item_updated");
       
       this.back();

    },
     uploadNextFile(news_id,index){
     
      if(index>=this.medias.length){
        this.allUploadFinished(news_id)
        return;
      }
      var media=this.medias[index];
      
      var fileName=media.fileName || "mediafile-has-no-name";
      
     // console.log("ul next:",media,index)
      var params={
        //group_id:this.group ? this.group.id : 0,
        file_name:fileName, /* filename has no extension if from google drive?*/
        id:news_id,
        exif_orientation:media.exifOrientation.toString(),
        //sort:index,
        token:this.appSettings.token,
      }
      
      var payload={media}
      eventBus.$emit("MEDIA_UPLOAD_START",payload);
      
    
    
     fileTransfer.uploadFile(media.url,this.upload_path,params).then(()=>{

        var payload={media}
        // start animate out gallery image
        eventBus.$emit("MEDIA_UPLOAD_DONE",payload);
        index+=1;

        setTimeout(()=>{
          // allow some time for animaion to finish
          this.uploadNextFile(news_id,index);
        },350)
        
        
        
      },error=>{
        alert("filetransfer error in update news item: "+error)
        this.buttonActive=true;
      })
      
    },
    toggleSticky(){
      
      this.check.sticky=!this.check.sticky;
    },
    addListeners(){
      eventBus.$on('UPLOAD_GALLERY_LOADING_DONE',()=>{
        this.buttonActive=true;
      })
    },
    removeListeners(){
      eventBus.$off('UPLOAD_GALLERY_LOADING_DONE');
    }

  },
  beforeDestroy(){
    this.removeListeners();
  },
  
  updated(){
  },
  mounted(){
      // get group by id
      this.group = this.groups.find(group => group.id === this.id);
      
       // load current album data
      this.loadNewsItem();

      this.addListeners();
      
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.thumbnail{
  width:100%;
  height:auto;
}
.thumbtack{
  font-size:1.5em;
  cursor:pointer;
}
</style>
